// common
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import ContextProvider from './ContextProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ContextProvider withGlobalStyle={true}>
    <App />
  </ContextProvider>
);
